<template>
  <base-modal
    hide-footer
    :size="'lg'"
    :modal-id="'add-privilege'"
    @hidden="$emit('onCloseModal')"
    @show="onModalOpen"
  >
    <template #modal-header>
      <div class="head-label">
        <span>Privilege List</span>
      </div>
    </template>
    <b-row>
      <b-col
        cols="12"
        class="px-2"
      >
        <div>
          <div class="d-flex flex-wrap justify-content-between">
            <v-select
              id="survey-type-status"
              class="v-select-filter bg-dropdown"
              placeholder="Status"
              :options="statusOption"
              @input="option => onSelectFilter('status', option)"
            />

            <div
              class="search-container mb-1 mb-md-0 mr-0 ml-0 ml-xl-2 ml-lg-1"
            >
              <search :on-search-input="onSetValueSearch" />
            </div>
          </div>
        </div>
      </b-col>
      <b-col
        cols="12"
        class="px-2 mt-2"
      >
        <overlay-loading :loading="loading.tableData">
          <template #content>
            <b-table
              :fields="fields"
              :items="privilegeList.payload"
              responsive
              bordered
              borderless
              sticky-header
              show-empty
              class="
              default-static-table
              no-color-head
              normal-height
              add-privilege-modal
            "
            >
              <template #cell(image_url)="data">
                <div class="d-flex justify-content-center align-item-center">
                  <img
                    :src="data.item.image_url || DefaultImg"
                    class="middle-image-column"
                  >
                </div>
              </template>
              <template #cell(nameEn)="data">
                <div class="inventory-name">
                  <b>En:</b> {{ data.item.name_en }}
                </div>
                <div class="inventory-name">
                  <b>Th:</b> {{ data.item.name_th }}
                </div>
              </template>
              <template #cell(privilege_type)="data">
                <div>
                  {{ data.item.type_desc }}
                </div>
              </template>
              <template #cell(status)="data">
                <div class="d-flex align-items-center">
                  <feather-icon
                    icon="CircleIcon"
                    class="mr-2"
                    :class="resolveStatusClass(data.item.status)"
                  />

                  <span>{{ resolveStatusLabel(data.item.status) }}</span>
                </div>
              </template>
              <template #cell(actions)="data">
                <add-button
                  :btn-label="'Add'"
                  :is-disabled="resolveEnableAddPrivilege(data.item)"
                  @click.native="$emit('onSelectPrivilege', data.item)"
                />
              </template>
              <template #table-busy>
                <overlay-loading :loading="true" />
              </template>
            </b-table>
          </template>
        </overlay-loading>
      </b-col>
      <b-col cols="12">
        <pagination-with-reorder
          :pagination="pagination"
          @pageChange="onPageChange"
        />
      </b-col>
    </b-row>
    <b-row class="modal-body-container mb-1" />
  </base-modal>
</template>

<script>
import BaseModal from '@/@core/components/base-modal/BaseModal.vue'
import Search from '@/views/components/search/Search.vue'
import AddButton from '@/views/components/button/AddButton.vue'
import DefaultImg from '@/assets/images/icons/no-img-square.jpg'
import PaginationWithReorder from '@/views/components/pagination/PaginationWithReorder.vue'
import useAddPrivilegeInventoryModal from '../hooks/useAddPrivilegeInventoryModal'

export default {
  components: {
    BaseModal,
    Search,
    AddButton,
    PaginationWithReorder,
  },
  props: { loadingOverlay: Object },
  setup(props) {
    const {
      pagination,
      onPageChange,
      onSetValueSearch,
      onSelectFilter,
      privilegeList,
      onModalOpen,
      fields,
      loading,
      resolveStatusClass,
      resolveStatusLabel,
      resolveEnableAddPrivilege,
      statusOption,
    } = useAddPrivilegeInventoryModal()
    return {
      DefaultImg,
      pagination,
      onPageChange,
      onSetValueSearch,
      onSelectFilter,
      privilegeList,
      onModalOpen,
      fields,
      loading,
      resolveStatusClass,
      resolveStatusLabel,
      resolveEnableAddPrivilege,
      statusOption,
    }
  },
}
</script>

<style scoped>
@import '~@/assets/css/pages/inventory/add-privilege.css';
@import '~@/assets/css/pages/default-static-table.css';
@import '~@/assets/css/override-styles/status.css';
@import '~@/assets/css/pages/inventory/inventory-manage.css';
</style>
